import {Injectable} from '@angular/core';
import {UserPermissionsApiService} from './api/user-permissions-api.service';
import {map, of, tap} from 'rxjs';
import {UserPermissionsManager} from '../common/elf-store/user-permissions/user-permissions.manager';
import {UserPermissionsQuery} from '../common/elf-store/user-permissions/user-permissions.query';
import {AuthService} from '../auth/shared/services/auth.service';
import {DashboardAccessMap} from '../../userway/sdk/UserWayApiClient';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsService {
  onceLoaded = false;
  constructor(
    private userPermissionsApi: UserPermissionsApiService,
    private userPermissionsManager: UserPermissionsManager,
    private userPermissionsQuery: UserPermissionsQuery,
    private authService: AuthService,
  ) {}

  checkUserPermissions(userPermissions: string | string[]) {
    return this.userPermissionsQuery.userPermissions$.pipe(
      map(data => {
        // Assume permission is granted and return true if userPermissions is not provided or is undefined
        if (!userPermissions) return true;

        if (Array.isArray(userPermissions)) {
          const permissions = userPermissions.map(permission => this.findPermissionValue(data, permission));
          return permissions.some(val => !!val);
        } else {
          return this.findPermissionValue(data, userPermissions);
        }
      }),
    );
  }

  loadUserPermissions(targetUserId: string) {
    if (this.onceLoaded) {
      return of({});
    }

    return this.userPermissionsApi.getUserPermissions(targetUserId).pipe(
      tap(data => {
        const accessMap = data.payload?.accessMap as DashboardAccessMap;
        this.userPermissionsManager.setUserPermissions(accessMap);
        this.onceLoaded = true;
      }),
    );
  }

  resetPermissions() {
    this.userPermissionsManager.reset();
    this.onceLoaded = false;
  }

  findPermissionValue(data: any, path: string): any {
    const keys = path.split('.');
    let value = data;

    for (const key of keys) {
      value = value[key];
    }

    if (value === undefined) {
      return false;
    }

    return value;
  }
}
